module.exports = __webpack_public_path__ + "static/media/Galdisa_YellowPumpkinSeeds.018dfcdc.pdf";